import { v4 as uuidv4 } from 'uuid'

export const LOGIN_JOURNEY_ID_KEY = 'login_journey_id'

/**
 * Sets the login journey ID in session storage
 * @param {string} loginJourneyId - The journey ID to store
 */
export const setLoginJourneyId = (loginJourneyId: string): void => {
  try {
    if (!loginJourneyId) {
      console.warn('Attempting to set empty login journey ID')
      return
    }
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(LOGIN_JOURNEY_ID_KEY, loginJourneyId)
    }
  } catch (error) {
    console.error('Error setting login journey ID', error)
  }
}

/**
 * Gets the login journey ID from session storage or generates a new one
 * @returns {string} The login journey ID
 */
export const getLoginJourneyId = (): string => {
  if (typeof window === 'undefined') {
    return uuidv4() // Return a new UUID for SSR
  }

  try {
    let journeyId = null
    if (typeof window !== 'undefined') {
      journeyId = sessionStorage.getItem(LOGIN_JOURNEY_ID_KEY)
    }
    if (!journeyId) {
      journeyId = uuidv4()
      setLoginJourneyId(journeyId)
    }
    return journeyId
  } catch (error) {
    console.error('Error getting login journey ID', error)
    return uuidv4()
  }
}

/**
 * Clears the login journey ID from session storage
 */
export const clearLoginJourneyId = (): void => {
  try {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(LOGIN_JOURNEY_ID_KEY)
    }
  } catch (error) {
    console.error('Error clearing login journey ID', error)
  }
}
